<template>
  <div class="modal-backdrop">
    <div class="modal">
      <header class="modal-header">
        <nav class="tabs">
          <button
            :class="{ active: activeTab === 'ocr' }"
            @click="activeTab = 'ocr'">
            OCR
          </button>
          <button
            :class="{ active: activeTab === 'anon' }"
            @click="activeTab = 'anon'">
            {{ $t('annonHelpModal.tabAnnonymisation') }}
          </button>
        </nav>
        <button type="button" class="btn-close" @click="close">x</button>
      </header>

      <section class="modal-body-ocr">
        <div v-if="activeTab === 'ocr'">
          <p>{{ $t('ocrHelpModal.1thP') }}</p>
          <p>{{ $t('ocrHelpModal.2ndP') }}</p>
          <p>{{ $t('ocrHelpModal.3rdP') }}</p>
          <br>
          <h3>{{ $t('ocrHelpModal.autoOcr') }}</h3>
          <p>{{ $t('ocrHelpModal.4thP') }}</p>
          <h3>OCR</h3>
          <p>{{ $t('ocrHelpModal.5thP') }}</p>
          <h3>{{ $t('ocrHelpModal.WoOcr') }}</h3>
          <p>{{ $t('ocrHelpModal.6thP') }}</p>
        </div>

        <div v-else-if="activeTab === 'anon'">
            <p>{{ $t('annonHelpModal.1thP1') }}<br>{{ $t('annonHelpModal.1thP2') }}</p>
            <section>
                <h3>Suffix</h3>
                <p>{{ $t('annonHelpModal.2ndP1') }}<br/>{{ $t("annonHelpModal.2ndP2") }}</p>
                <h3>Prefix</h3>
                <p>{{ $t('annonHelpModal.3rdP1') }}<br/>{{ $t("annonHelpModal.3rdP2") }}</p>
                <h3>Prefix + Suffix</h3>
                <p>{{ $t('annonHelpModal.4thP1') }}<br/>{{ $t("annonHelpModal.4thP2") }}</p>
                <h3>{{$t('annonHelpModal.exactMatch')}}</h3>
                <p>{{ $t('annonHelpModal.5thP1') }}<br/>{{ $t('annonHelpModal.5thP2') }}</p>
                <h3>{{$t('annonHelpModal.withoutSettings')}}</h3>
                <p>{{ $t('annonHelpModal.6thP1') }}<br/>{{ $t('annonHelpModal.6thP2') }}</p>
            </section>
            </div>
      </section>

      <footer class="modal-footer">
        <!-- Optional footer content -->
      </footer>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ocrHelpModal',
    data() {
        return {
        activeTab: 'ocr', // predvolená záložka
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/css/components/OcrHelpModal.scss" />
